import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppSearch from './AppSearch';
import AppSearchResults from './AppSearchResults';
import reportWebVitals from "./reportWebVitals";

const config_root = window.bn_config_search_page.root;
const config_root_input = window.bn_config_search_page.root_input;
const elementRoot = document.querySelector(config_root);
let root = elementRoot ? ReactDOM.createRoot(document.querySelector(config_root)) : null;
let rootElements = [];
let root_inputElements = [];
let actuallyElementRoot = config_root;
let actuallyElementRootInput = config_root_input;


if (window.bn_config_search_page && window.bn_config_search_page.mountOnStart) {
  root.render(
    <Fragment>
      <App />
    </Fragment>
  );
}

window.beonMountSearchPage = function (rootElement) {
  if (rootElement) actuallyElementRoot = rootElement;
  var elementsToShow = document.querySelectorAll(actuallyElementRoot);
  elementsToShow.forEach((el) => {
    var elm = ReactDOM.createRoot(el);
    elm.render(
      <Fragment>
        <AppSearchResults />
      </Fragment>
    );
    rootElements.push(elm);
  })
};

window.beonMountSearchInput = function (rootElement) {
  if (rootElement) actuallyElementRootInput = rootElement;
  var elementsToShow = document.querySelectorAll(actuallyElementRootInput);
  elementsToShow.forEach((el) => {
    var elm = ReactDOM.createRoot(el);
    elm.render(
      <React.StrictMode>
        <AppSearch />
      </React.StrictMode>
    );
    root_inputElements.push(elm);
  });
};

window.beonUnmountSearchPage = function () {
  rootElements.forEach((el) => {
    el.unmount(el);
  });
};

window.beonUnmountSearchInput = function () {
  root_inputElements.forEach((el) => {
    el.unmount(el);
  });
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
